import { Route, Routes } from "react-router-dom";

// Normal Site Pages
import Home from "../pages/Home";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import CartDrawer from "../pages/CartDrawer";
import CheckoutPage from "../pages/CheckoutPage";
import ProductDetailPage from "../pages/ProductDetailPage";
import ProductListPage from "../pages/ProductList";
import DealsPage from "../pages/DealsPage";

// Admin
import AdminLayout from "../layout/AdminLayout";
import AdminApp from "../pages/AdminPage";
import AdminAddProduct from "../layout/AdminAddProduct";
import AdminProducts from "../layout/AdminProducts";
import AdminEditProduct from "../layout/AdminEditProducts";
import AdminBulkUpload from "../layout/AdminBulkUpload";
import AdminDiscounts from "../layout/AdminDiscounts";
import AllProductsPage from "../pages/AllProducts";

const RoutePath = () => {
  return (
    <Routes>

      {/* =======================
          NORMAL SITE
      ======================= */}

      <Route path="/" element={<Home />} />

      {/* Kategorilere göre ürün listeleme */}
      <Route path="/category/:categoryName" element={<ProductListPage />} />

      {/* Ürün Detay Sayfası */}
      <Route path="/product/:id" element={<ProductDetailPage />} />

      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/cart-drawer" element={<CartDrawer />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/all-product" element={<AllProductsPage />} />

      {/* Deals Page */}
      <Route path="/gunun-firsatlari" element={<DealsPage />} />


      {/* Admin Ürün Ekle */}
      <Route path="/admin/add-product" element={<AdminAddProduct />} />
      <Route path="/admin/bulk-upload" element={<AdminBulkUpload />} />

      {/* =======================
            ADMIN PANEL
      ======================= */}

      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/discounts" element={<AdminDiscounts />} />

        {/* Ürün Düzenleme */}
        <Route path="/admin/edit-product/:productId" element={<AdminEditProduct />} />

      </Route>

    </Routes>
  );
};

export default RoutePath;
